import $ from 'jquery';
import { getDOMFillerCard } from '../components/async/async-fillers.js';
import 'slick-carousel';

function initSlider($slider, initial = 4, type, $currentSlide, $group) {
  $slider.on('init beforeChange', function (event, slick) {
    if (slick.$dots) {
      const dots = slick.$dots.find('li');
      const theme = $group.find(`.slide-m-dots-featured-slider-${type}`).data('theme');
      if (theme) {
        dots.addClass(theme);
      }
    }
  });

  $slider.slick({
    slidesToShow: initial,
    slidesToScroll: initial,
    autoplay: false,
    dots: true,
    arrows: true,
    infinite: true,
    appendDots: $(`.slide-m-dots-featured-slider-${type}`),
    nextArrow: $(`.slide-m-next-featured-slider-${type}`),
    prevArrow: $(`.slide-m-prev-featured-slider-${type}`),
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '8%',
        },
      },
    ],
  });

  // sets position
  $slider.on('init beforeChange afterChange', function (event, slick) {
    $slider.slick('setPosition');
  });

  // Adjusts height of all slides to the tallest one
  $slider.on('setPosition', function (e, slick) {
    slick.$slides.css('height', slick.$slideTrack.height() + 'px');
  });

  $slider.on('init reInit afterChange', function (event, slick, currentSlide) {
    const current = (currentSlide ? currentSlide : 0) + 1;
    if ($currentSlide) {
      $currentSlide.text(current + '/' + slick.slideCount);
    }
  });
}

function initializeFeaturedGroup($group) {
  const $currentSlide = $group.find('.slider-current-item');
  const $featuredSlider = $group.find('.featured-slider');
  const initial = $featuredSlider.data('initial');
  const type = $group.data('type');
  const hasSlider = $group.data('has-slider');
  let fillerCardConfig = $group.data('filler-card');


  if (fillerCardConfig) {
    $featuredSlider.append(getDOMFillerCard(fillerCardConfig));
  }


  if (hasSlider) {
    initSlider($featuredSlider, initial, type, $currentSlide, $group);
  }
  


}


if ($('.dsp-featured-non-async').length) {

  $('.dsp-featured-non-async').each(function () {
    initializeFeaturedGroup($(this));
  });

}


